__webpack_require__.ruid = "bundler=rspack@1.5.0";
